import { tv } from '@workspace/lib';

export const cardGridVariants = tv({
  slots: {
    section: '',
    container: '',
    grid: '',
    card: 'gap-3 md:gap-sm',
    imageWrapper: '',
    image: '',
    content: '',
    titleRow: 'flex-row items-center',
    title: 'text-black',
    arrow: 'shrink-0 text-primary-300',
    description: 'text-black font-light',
  },
  variants: {
    position: {
      first: {},
      last: {},
    },
  },
});
